import { JACKPOTS_TYPES, actionTypes as coreActionTypes } from './constants';
import { IJackpot } from '@core/js/hooks/useGetJackpots/types';
// TODO: rewrite jackpots

export type TJackpots = Record<string, IJackpot>

enum ExtendedActionTypes {
    SET_SKYWIND_AND_GREENTUBE = 'SET_SKYWIND_AND_GREENTUBE'
}

export const actionTypes = {
    ...coreActionTypes,
    ...ExtendedActionTypes
} as const;

export interface IJackpotState {
    [JACKPOTS_TYPES.JACKPOTS]?: TJackpots;
    [JACKPOTS_TYPES.GREEN_TUBE_JACKPOTS]?: TJackpots;
    [JACKPOTS_TYPES.SKY_WIND_JACKPOT]?: TJackpots;
    [JACKPOTS_TYPES.VF_JACKPOTS]?: TJackpots;
    jackpotStartTime: number | null;
}

export type TSetJackpotActionPayload = {
    jackpotType?: JACKPOTS_TYPES;
    [JACKPOTS_TYPES.JACKPOTS]?: TJackpots;
    [JACKPOTS_TYPES.GREEN_TUBE_JACKPOTS]?: TJackpots;
    [JACKPOTS_TYPES.SKY_WIND_JACKPOT]?: TJackpots;
    [JACKPOTS_TYPES.VF_JACKPOTS]?: TJackpots;
}
export interface ISetJackpotsAction {
    type: typeof actionTypes.SET_JACKPOTS;
    payload: TSetJackpotActionPayload;
}

export interface ISetSkywindAndGreentubeJackpotsAction {
    type: typeof actionTypes.SET_SKYWIND_AND_GREENTUBE;
    payload: TSetJackpotActionPayload;
}
